import React, { useState, useCallback, useRef } from 'react';
import store from '../../store/store';
import { arrangementsSlice, arrangementsSelectors } from '../../store/arrangement/arrangements';

export default function DisclosureContainer(props) { 
  const arrangement = arrangementsSelectors.selectById(store.getState(), props.id); 
  return (
    <div>{props.id}</div>
  );
}